export class EditLockDto {

  public id!: string;
  public locked!: boolean;

  // internal use for the interval
  public timeout: any = -1;

  constructor(init?: Partial<EditLockDto> | undefined) {
    Object.assign(this, init);
  }

  public static init(): EditLockDto {
    return new EditLockDto({locked: false, timeout: -1});
  }

  public isLocked(): boolean {
    return this.locked;
  }

  public isUnlocked(): boolean {
    return !this.isLocked();
  }
}
